export default __webpack_public_path__ + "static/media/gplay.f902960a.png";